import initSharedPromotion from '@resources/js/components/promotion/initSharedPromotion'
import '@resources/js/analytics'

initSharedPromotion()
